<template>
  <v-dialog
    :value="value"
    max-width="520"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="headline">
        Generer gavekort
      </v-card-title>
      <v-card-text>
        <v-form
          ref="formRef"
          lazy-validation
        >
          <v-select
            v-model="localForm.giftCardTypeId"
            :items="types"
            item-text="name"
            item-value="id"
            label="Gavekorttype"
            outlined
            dense
            :rules="[v => !!v || 'Velg en gavekorttype']"
          />
          <v-text-field
            v-model.number="localForm.quantity"
            label="Antall"
            type="number"
            outlined
            dense
            :rules="[v => v > 0 || 'Antall må være større enn 0']"
          />
          <v-text-field
            v-model="localForm.name"
            label="Navn på batch (valgfritt)"
            outlined
            dense
          />
          <v-textarea
            v-model="localForm.notes"
            label="Notat (valgfritt)"
            outlined
            auto-grow
            rows="2"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="handleClose"
        >
          Avbryt
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!localForm.giftCardTypeId || localForm.quantity <= 0"
          @click="handleGenerate"
        >
          Generer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IGiftCardTypeDTO, IGenerateGiftCardBatchDTO } from "@shared/types";

interface GiftCardBatchForm extends IGenerateGiftCardBatchDTO {
  name: string;
  notes: string;
}

@Component({
  name: "gift-card-batch-dialog",
})
export default class GiftCardBatchDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ required: true }) types!: IGiftCardTypeDTO[];
  @Prop({ required: true }) formData!: GiftCardBatchForm;

  public localForm: GiftCardBatchForm = {
    giftCardTypeId: null as any,
    quantity: 10,
    name: "",
    notes: "",
  };

  @Watch("formData", { immediate: true, deep: true })
  onFormDataChange(val: GiftCardBatchForm) {
    this.localForm = { ...val };
  }

  @Watch("value")
  onValueChange(isOpen: boolean) {
    if (isOpen && this.types.length > 0 && !this.localForm.giftCardTypeId) {
      this.localForm.giftCardTypeId = this.types[0].id;
    }
  }

  public handleClose(): void {
    this.$emit("input", false);
  }

  public handleGenerate(): void {
    this.$emit("generate", this.localForm);
  }
}
</script>
